"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

import CloseIcon from "@repo/ui-system/icons/action/close/outline.svg";
import SearchIcon from "@repo/ui-system/icons/action/search/outline.svg";

import { PageCenter } from "@/components/ui/page-center";

import { SearchCombobox } from "../search-combobox";
import { useScrollBlur } from "./use-scroll-blur";

type Props = {
  className?: string;
};

export function MobileSearch({ className }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  useScrollBlur(isOpen);

  return (
    <div className={className}>
      <button
        type="button"
        aria-label="Search"
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-1.5 p-2 text-[14px] font-semibold text-[#1e1e1e]"
      >
        <SearchIcon className="size-5" />
      </button>
      {isOpen && (
        <PageCenter className="absolute z-base inset-0 bg-surface-grayscale-subtle flex flex-row gap-2 items-center justify-between">
          <SearchCombobox
            autoFocus={isOpen}
            className="w-full"
          />
          <button
            type="button"
            aria-label="Close"
            onClick={() => setIsOpen(false)}
            className="p-2 -translate-x-2 order-first"
          >
            <CloseIcon className="size-6" />
          </button>
        </PageCenter>
      )}
    </div>
  );
}
